import { Charts } from './Charts';
import HouseholdExpensesChartsDataProvider from './contexts/HouseholdExpensesChartsDataContext';

const HouseholdExpensesWrapper = () => {
    return (
        <HouseholdExpensesChartsDataProvider>
            <Charts />
        </HouseholdExpensesChartsDataProvider>
    );
};

export default HouseholdExpensesWrapper;
